import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Modal } from 'ui-components/components/modal';
import { testId } from 'ui-components/services/testid-service';

import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import ErrorBoundary from '../../components/error-boundary';

import MarkAsShipped from './index';
import BulkMarkAsShipped from './bulk/index';
import { BULK_MAS_PAGE, BASE_MAS_PAGE } from './constants';

import style from './style.module.less';

const MarkAsShippedModal = ({ modalFrameworkMethods, page = BASE_MAS_PAGE }) => {
  const [currentPage, setPage] = useState(page);

  const { closeModal } = modalFrameworkMethods;
  return (
    <ErrorBoundary errorMessageId='markAsShippedModal'>
      <Modal {...testId('mark-as-shipped-modal')} className={classnames(style['many-modal'])}>
        {currentPage === BULK_MAS_PAGE ? (
          <BulkMarkAsShipped closeModal={closeModal} setPage={setPage} />
        ) : (
          <MarkAsShipped closeModal={closeModal} />
        )}
      </Modal>
    </ErrorBoundary>
  );
};

MarkAsShippedModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  page: PropTypes.number,
};

export default MarkAsShippedModal;
